import React, { useEffect, useState } from "react";
import api from "../api/api";
import { useNavigate } from "react-router-dom";
import "./HospitalPharmacistDashboard.css";
import axios from "../api/axiosInstance";

export default function HospitalPharmacistDashboard() {
  const navigate = useNavigate();
const [stats, setStats] = useState({
  total_earning: 0,
  total_orders: 0,
});
const [finance, setFinance] = useState({
  total_earned: 0,
  total_settled: 0,
  pending_balance: 0,
});

  const [hospitalName, setHospitalName] = useState("");
  const [pharmacistName, setPharmacistName] = useState("");
  const [pharmacistPhone, setPharmacistPhone] = useState("");

  const [summary, setSummary] = useState({
    pending: 0,
    completed: 0,
    rejected: 0,
  });
const [settlements, setSettlements] = useState([]);
const [showHistory, setShowHistory] = useState(false);

  const [loading, setLoading] = useState(true);

  const logout = () => {
    localStorage.clear();
    navigate("/login");
  };

  useEffect(() => {
    loadDashboard();
  }, []);

useEffect(() => {
  axios.get("/pharmacist/finance/")
    .then(res => setFinance(res.data));
}, []);



useEffect(() => {
  axios.get("/dashboard/hospital-earnings/")
    .then(res => setStats(res.data))
    .catch(err => console.error(err));
}, []);

const loadSettlementHistory = () => {
  axios.get("/pharmacist/settlements/")
    .then(res => setSettlements(res.data));
};



  const loadDashboard = async () => {
    try {
      const res = await api.get("hospital-pharmacist/requests/");
      console.log("DASHBOARD DATA:", res.data);

      // 🔹 SUMMARY
      setSummary({
        pending: res.data.pending,
        completed: res.data.completed,
        rejected: res.data.rejected,
      });

      // 🔹 HEADER INFO
      setHospitalName(res.data.hospital_name);
      setPharmacistName(res.data.pharmacist_name);
      setPharmacistPhone(res.data.pharmacist_phone);

    } catch (err) {
      console.error("Failed to load pharmacist dashboard", err);
    } finally {
      setLoading(false);
    }
  };

  const goToRxDashboard = () => {
    navigate("/pharmacist/rx-dashboard");
  };

  if (loading) {
    return <p className="center">Loading...</p>;
  }







 return (
  <div className="hp-container">

    {/* ================= HEADER ================= */}
    <div className="hp-header">

      {/* LEFT : Avatar + Pharmacist Info */}
      <div className="hp-left">
        <div className="hp-avatar">
          {pharmacistName
            ? pharmacistName.charAt(0).toUpperCase()
            : "P"}
        </div>

        <div className="hp-pharmacist-info">
          <p className="hp-name">{pharmacistName}</p>
          <p className="hp-phone">{pharmacistPhone}</p>
        </div>
      </div>

      {/* CENTER : Hospital Name */}
      <div className="hp-center">
        <h2 className="hp-hospital">{hospitalName}</h2>
      </div>









      {/* RIGHT : Logout */}
      <div className="hp-right">
        <button onClick={logout} className="logout-btn">
          Logout
        </button>
      </div>


    </div>
{showHistory && (
  <div className="modal">
    <div className="modal-box large">
      <h3>💰 Settlement History</h3>

      {settlements.length === 0 ? (
        <p>No settlements yet</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Amount</th>
              <th>Admin Note</th>
            </tr>
          </thead>
          <tbody>
            {settlements.map((s, i) => (
              <tr key={i}>
                <td>{new Date(s.date).toLocaleString()}</td>
                <td style={{ color: "green" }}>₹{s.amount}</td>
                <td>{s.note}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <button onClick={() => setShowHistory(false)}>Close</button>
    </div>
  </div>
)}

    {/* ================= SUMMARY ================= */}
    <div className="hp-summary">
      <div className="card pending" onClick={goToRxDashboard}>
        <span>Pending</span>
        <strong>{summary.pending}</strong>
      </div>

      <div className="card completed" onClick={goToRxDashboard}>
        <span>Completed</span>
        <strong>{summary.completed}</strong>
      </div>

      <div className="card rejected" onClick={goToRxDashboard}>
        <span>Rejected</span>
        <strong>{summary.rejected}</strong>
      </div>

           <div className="card rejected" onClick={goToRxDashboard}>
        <span>Total Earned</span>
        <strong>₹{Number(stats.total_earning).toFixed(2)}</strong>
      </div>

           <div className="card rejected" onClick={goToRxDashboard}>
        <span>Total Settled</span>
        <strong><p style={{ color: "green" }}>₹{finance.total_settled}</p></strong>
      </div>

           <div className="card rejected" onClick={goToRxDashboard}>
        <span>Pending Balance</span>
        <strong>₹{finance.pending_balance}</strong>
      </div>







    </div>

    {/* CTA */}
    <div className="hp-tabs">
      <button className="view-status-btn" onClick={goToRxDashboard}>
        VIEW STATUS
      </button>
<button className="view-status-btn" onClick={() => {
  loadSettlementHistory();
  setShowHistory(true);
}}>
  View Settlement History
</button>
    </div>




  </div>
);

}
